import { motion } from 'framer-motion';
// Utils & misc
import cn from '../../../utils/cn';
// Style
import styles from './Skeleton.module.css';

const skeletonVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

/**
 * @param {object} props
 * @param {('round' | 'rectangle')} props.shape - The shape of the skeleton
 * @param {string} props.width - The width of the skeleton
 * @param {string} props.height - The height of the skeleton
 * @param {('default' | 'table')} [props.theme] - The theme of the skeleton
 * @param {string} [props.className] - The class name of the skeleton
 * @param {object} [props.style] - The style of the skeleton
 * @param {boolean} [props.noAnimation=false] - Whether to disable the animation
 * @returns {JSX.Element} The skeleton component
 */
export function Skeleton({
  shape, width, height, theme = 'default', className = null, style = {}, noAnimation = false,
}) {
  return (
    <motion.div
      className={cn([styles.skeleton, styles[shape], styles[theme], className])}
      style={{
        width, height, ...style,
      }}
      initial="hidden"
      animate="visible"
      exit="hidden"
      variants={noAnimation ? undefined : skeletonVariants}
      transition={{ duration: 0.5 }}
    />
  );
}

export default Skeleton;
